
<template>
  <div class="home">
    
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {

  }

}

</script>